import { C } from '../../../styles/theme';
// Shared primitives for the Employee Detail tabs.

export { C };export const FONT = "'Plus Jakarta Sans', sans-serif";

const AVATAR_PALETTE = ['#2563eb', '#2563eb', '#7c3aed', '#d97706', '#0891b2', '#dc2626', '#0d9488'];
export const avatarColor = (name = '') => AVATAR_PALETTE[(name.charCodeAt(0) || 0) % AVATAR_PALETTE.length];
export const initials = (name = '') => name.trim().split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();

export const fmtMoney = (currency, amount) => `${currency}${Number(amount || 0).toFixed(2)}`;

export const fmtDate = (value) => {
    if (!value) return '—';
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d?.getTime?.())) return '—';
    return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

export const fmtDateTime = (value) => {
    if (!value) return '—';
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d?.getTime?.())) return '—';
    return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const cardStyle = {
    background: C.white,
    border: `1px solid ${C.border}`,
    borderRadius: 12,
    padding: 20,
};

export const cardHeaderStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 16,
};

export const cardTitleStyle = {
    fontSize: 14,
    fontWeight: 700,
    color: C.text,
    margin: 0,
};

export const labelStyle = {
    fontSize: 11,
    fontWeight: 700,
    color: C.mutedLight,
    textTransform: 'uppercase',
    letterSpacing: 0.8,
    display: 'block',
    marginBottom: 4,
};

export const valueStyle = {
    fontSize: 13,
    fontWeight: 500,
    color: C.text,
};

export const inputStyle = {
    width: '100%',
    border: `1px solid ${C.border}`,
    borderRadius: 7,
    padding: '8px 11px',
    fontSize: 13,
    color: C.text,
    outline: 'none',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
    background: C.white,
};

export const primaryButtonStyle = {
    background: C.green,
    color: C.white,
    border: 'none',
    borderRadius: 7,
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'background 0.15s',
    fontFamily: 'inherit',
};

export const secondaryButtonStyle = {
    background: C.white,
    color: C.textLight,
    border: `1px solid ${C.border}`,
    borderRadius: 7,
    padding: '8px 16px',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
};

export const ghostButtonStyle = {
    background: 'none',
    border: 'none',
    color: C.muted,
    fontSize: 12,
    fontWeight: 600,
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: 6,
};

export const linkButtonStyle = {
    background: 'none',
    border: 'none',
    color: C.green,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    padding: 0,
};
